export const CLASS_PROFICIENCIES = {
    'Barbarian': {
        armor: ['Light Armor', 'Medium Armor', 'Shields'],
        weapons: ['Simple Weapons', 'Martial Weapons'],
        tools: [],
        savingThrows: ['Strength', 'Constitution']
    },
    'Bard': {
        armor: ['Light Armor'],
        weapons: ['Simple Weapons', 'Hand Crossbow', 'Longsword', 'Rapier', 'Shortsword'],
        tools: [],
        savingThrows: ['Dexterity', 'Charisma']
    },
    'Cleric': {
        armor: ['Light Armor', 'Medium Armor', 'Shields'],
        weapons: ['Simple Weapons'],
        tools: [],
        savingThrows: ['Wisdom', 'Charisma']
    },
    'Druid': {
        armor: ['Light Armor', 'Medium Armor', 'Shields (non-metal)'],
        weapons: ['Clubs', 'Daggers', 'Darts', 'Javelins', 'Maces', 'Quarterstaffs', 'Scimitars', 'Sickles', 'Slings', 'Spears'],
        tools: ['Herbalism Kit'],
        savingThrows: ['Intelligence', 'Wisdom']
    },
    'Fighter': {
        armor: ['All Armor', 'Shields'],
        weapons: ['Simple Weapons', 'Martial Weapons'],
        tools: [],
        savingThrows: ['Strength', 'Constitution']
    },
    'Monk': {
        armor: [],
        weapons: ['Simple Weapons', 'Shortswords'],
        tools: [],
        savingThrows: ['Strength', 'Dexterity']
    },
    'Paladin': {
        armor: ['All Armor', 'Shields'],
        weapons: ['Simple Weapons', 'Martial Weapons'],
        tools: [],
        savingThrows: ['Wisdom', 'Charisma']
    },
    'Ranger': {
        armor: ['Light Armor', 'Medium Armor', 'Shields'],
        weapons: ['Simple Weapons', 'Martial Weapons'],
        tools: [],
        savingThrows: ['Strength', 'Dexterity']
    },
    'Rogue': {
        armor: ['Light Armor'],
        weapons: ['Simple Weapons', 'Hand Crossbow', 'Longsword', 'Rapier', 'Shortsword'],
        tools: ['Thieves\' Tools'],
        savingThrows: ['Dexterity', 'Intelligence']
    },
    'Sorcerer': {
        armor: [],
        weapons: ['Daggers', 'Darts', 'Slings', 'Quarterstaffs', 'Light Crossbows'],
        tools: [],
        savingThrows: ['Constitution', 'Charisma']
    },
    'Warlock': {
        armor: ['Light Armor'],
        weapons: ['Simple Weapons'],
        tools: [],
        savingThrows: ['Wisdom', 'Charisma']
    },
    'Wizard': {
        armor: [],
        weapons: ['Daggers', 'Darts', 'Slings', 'Quarterstaffs', 'Light Crossbows'],
        tools: [],
        savingThrows: ['Intelligence', 'Wisdom']
    }
};

export const RACE_PROFICIENCIES = {
    'Human': {
        languages: ['Common', 'One Extra Language']
    },
    'Elf': {
        languages: ['Common', 'Elvish'],
        skills: ['Perception']
    },
    'High Elf': {
        weapons: ['Longsword', 'Shortsword', 'Shortbow', 'Longbow'],
        languages: ['One Extra Language']
    },
    'Wood Elf': {
        weapons: ['Longsword', 'Shortsword', 'Shortbow', 'Longbow']
    },
    'Drow': {
        weapons: ['Rapier', 'Shortsword', 'Hand Crossbow']
    },
    'Dwarf': {
        weapons: ['Battleaxe', 'Handaxe', 'Light Hammer', 'Warhammer'],
        tools: [],
        languages: ['Common', 'Dwarvish']
    },
    'Halfling': {
        languages: ['Common', 'Halfling']
    },
    'Dragonborn': {
        languages: ['Common', 'Draconic']
    },
    'Gnome': {
        languages: ['Common', 'Gnomish']
    },
    'Tiefling': {
        languages: ['Common', 'Infernal']
    },
    'Orc': {
        languages: ['Common', 'Orc']
    },
    'Goliath': {
        languages: ['Common', 'Giant'],
        skills: ['Athletics']
    },
    'Aasimar': {
        languages: ['Common', 'Celestial']
    }
};
